<template>
    <div class="d-flex align-center justify-center width-100 mt-4" :style="{'padding-right': scrollBar+'px !important'}">
        <div class="teamName">{{gamedata.team_a_name}}</div>
        <div class="placeholder"></div>
        <div class="teamName">{{gamedata.team_b_name}}</div>
    </div>
</template>

<script>
    export default {
        name: 'DmrTeams',
        props: {
            gamedata: Object,
            scrollBar: Number
        },
    }
</script>

<style scoped>
    .timelineItemText {
        font-size: 12px;
        font-stretch: condensed;
        width: 220px;
    }

    .placeholder {
        width: 90px;
    }

    .teamName {
        width: calc(50% - 45px);
    }

    .teamName:first-child {
        text-align: right;
    }
</style>
